import { useEffect, useState } from "react";
import { CornerDownRight } from "lucide-react";
import { useParams } from "react-router-dom";
import { api } from "../../connect/api";
import { Avatar, CEO_TITLE, dayLabel, Empty, Header, Spinner } from "./ui";

const Card = ({ p }) => (
  <article className={`nxc-card p-3.5 nxc-fade-in ${p.is_ceo ? "!border-amber-500/40 !bg-amber-950/20" : ""}`} data-testid={`group-post-${p.id}`}>
    <div className="flex items-center gap-2.5">
      <Avatar name={p.sender.name} src={p.sender.avatar} size={38} ceo={p.is_ceo} />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2"><span className="font-semibold text-slate-100 truncate">{p.sender.name}</span>{p.is_ceo && <span className="text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded bg-amber-500/20 text-amber-300 border border-amber-500/40 shrink-0 whitespace-nowrap">CEO</span>}</div>
        <div className="text-[11px] text-slate-400 truncate">{p.is_ceo ? CEO_TITLE : `${p.sender.title || ""} · ${p.sender.department}`}</div>
      </div>
      <div className="text-[11px] text-slate-500 shrink-0">{dayLabel(p.posted_at)}</div>
    </div>
    <p className="mt-2.5 text-sm text-slate-200 leading-relaxed whitespace-pre-wrap">{p.text}</p>
  </article>
);

export const GroupPost = () => {
  const { pid } = useParams();
  const [post, setPost] = useState(undefined);
  useEffect(() => { api.get(`/group/posts/${pid}`).then((r) => { setPost(r.data); api.post("/group/opened", { post_ids: [pid] }).catch(() => {}); }).catch(() => setPost(null)); }, [pid]);
  return (
    <div className="h-full flex flex-col">
      <Header title="Announcement" sub="All Staff · India" back />
      <div className="flex-1 overflow-y-auto px-3 py-3 space-y-2.5" data-testid="group-post-detail">
        {post === undefined && <div className="flex justify-center py-10"><Spinner /></div>}
        {post === null && <Empty title="Post not found" />}
        {post && <Card p={post} />}
        {post?.replies?.length > 0 && (
          <>
            <div className="text-[11px] uppercase tracking-wider text-slate-500 px-1 flex items-center gap-1"><CornerDownRight size={12} /> CEO replies</div>
            {post.replies.map((r) => <Card key={r.id} p={r} />)}
          </>
        )}
      </div>
    </div>
  );
};
